import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { MyBooksRequest } from '../../requests/platform/my-books.request';
import { MyBooksResponse } from '../../responses/platform/my-books.response';

@Injectable({
  providedIn: 'root'
})
export class MyBooksService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public postMyBooks(request: MyBooksRequest): Observable<MyBooksResponse> {
    return this.http
      .post<MyBooksResponse>(environment.urlApiPlatform + 'MyBooks',request,this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}